var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{attrs:{"for":"dropdown"}},[_vm._v(_vm._s(_vm.element.text))]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"dropdown","multiple":""}},_vm._l((_vm.element.values),function(value){return _c('option',{domProps:{"value":value}},[_vm._v(_vm._s(value))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }